import { Firebase } from "@/services/firebase";

export default function(doc, id, store) {
  if (!docketData.url || !docketData.sitename) {
    console.warn("url or sitename not defined");
    return false;
  }

  if (doc.url !== docketData.url || doc.name !== docketData.sitename) {
    console.warn("project url or name has changed");

    // cache for 100 seconds
    if (doc?.sync?.name_and_url) {
      if (
        (Firebase.firestore.Timestamp.now().toMillis() -
          doc.sync.name_and_url) /
          1000.0 <
        100
      ) {
        console.log("project data changed, but still cached.");
        return false;
      }
    }

    // sync name and url
    store.dispatch("project/patch", {
      id,
      name: docketData.sitename,
      url: docketData.url,
      sync: {
        name_and_url: Firebase.firestore.Timestamp.now().toMillis(),
      },
    });
  }
}
